import ContactList from "./Contacts/ContactList";
import {UserAddressingWaysWithLocalization} from "./Verification/Enums/UserAddressingWaysWithLocalization";

export default class RecapTableBuilder {
    private readonly localization: Localization;
    private readonly contactList: ContactList;
    private readonly buildActionHtml: (verifyCheckbox: JQuery) => Promise<string> | string;

    constructor(
        localization: Localization,
        buildActionHtmlCallback: (verifyCheckbox: JQuery) => Promise<string> | string,
        contactList: ContactList = null,
    ) {
        this.localization = localization;
        this.contactList = contactList;
        this.buildActionHtml = buildActionHtmlCallback;
    }

    public async buildRecapTable(recapRowItems: IRecapRowItem[]): Promise<JQuery<HTMLElement>> {
        const table = jq("<table class=\"table\">");
        const tableBody = jq("<tbody>");
        for (const rowItem of recapRowItems) {
            const formRow = await this.getTableRowAsync(rowItem);
            tableBody.append(formRow);
        }

        if (this.contactList !== null) {
            const contacts = this.contactList.getRecapTableRows();
            tableBody.append(contacts);
        }
        table.append(tableBody);
        return table;
    }

    private async getTableRowAsync(recapRowItem: IRecapRowItem): Promise<JQuery<HTMLElement>> {
        const tableRow = jq("<tr>");
        let value = "";
        const promises = [];
        let promise;
        const nullValueTranslation = await this.localization.translateAsync("null-value", "verification");
        recapRowItem.valueInputs.each((index, element) => {
            const elementJq = jq(element);
            const inputVal = elementJq.val();
            if (elementJq.hasClass("user-data-select") && elementJq.hasClass("title")) {
                const titleKey = UserAddressingWaysWithLocalization[inputVal as number];
                if (inputVal !== UserAddressingWaysWithLocalization.None.toString(10)) {
                    promise = this.localization.translateAsync(titleKey, "UserAddressingWaysWithLocalization");

                    promise.then((titleKeyTranslation) => {
                        value += titleKeyTranslation.result.value;
                    });

                    promises.push(promise);
                }
            } else if (inputVal.toString().length !== 0) {
                value += `${inputVal}`;
                if (index !== recapRowItem.valueInputs.length - 1) {
                    value += `${recapRowItem.separator}`;
                }
            }
        });

        await Promise.all(promises);
        if (value.length === 0) {

            value = `<em class="text-secondary">\<${nullValueTranslation.result.value}\></em>`;
        }

        const actionValueHtml = await this.buildActionHtml(recapRowItem.verifyCheckboxElement);

        tableRow
            .append(`<th scope="row">${recapRowItem.label}</th>`)
            .append(`<td>${value}</td>`)
            .append(`<td>${actionValueHtml}</td>`);

        return tableRow;
    }
}

export interface IRecapRowItem {
    label: string;
    separator: string;
    valueInputs: JQuery<HTMLElement>;
    verifyCheckboxElement: JQuery<HTMLElement>;
}
